function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10V4C5.5 3.175 6.1675 2.5 7 2.5H13.75V1.75C13.75 0.925 13.075 0.25 12.25 0.25H1.75C0.9175 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.9175 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V11.5H7C6.1675 11.5 5.5 10.825 5.5 10ZM7.75 4C7.3375 4 7 4.3375 7 4.75V9.25C7 9.6625 7.3375 10 7.75 10H14.5V4H7.75ZM10 8.125C9.3775 8.125 8.875 7.6225 8.875 7C8.875 6.3775 9.3775 5.875 10 5.875C10.6225 5.875 11.125 6.3775 11.125 7C11.125 7.6225 10.6225 8.125 10 8.125Z",
  fill: "white"
});

const SvgBalance = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBalance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Balance.6b64f845.svg";
export { ForwardRef as ReactComponent };